import { render, staticRenderFns } from "./CollectionGallery.vue?vue&type=template&id=51b35f68"
import script from "./CollectionGallery.vue?vue&type=script&lang=js"
export * from "./CollectionGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports